import React, { useEffect, useRef, useState } from 'react';
import { Sun, Phone, Youtube } from 'lucide-react';
import "../styles/FloatButton.css";

const FloatButton = () => {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    // Cerrar al tocar fuera o al pulsar Escape
    useEffect(() => {
        if (!open) return;

        const handlePointerDown = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') setOpen(false);
        };

        document.addEventListener('pointerdown', handlePointerDown);
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('pointerdown', handlePointerDown);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [open]);

    return (
        <div
            className={`fab${open ? ' is-open' : ''}`}
            ref={containerRef}
        >
            <ul className="fab__options">
                <li>
                    <a href="tel:+13109254824" className="fab__link">
                        <span className="fab__label">(310) 925-4824</span>
                        <span className="fab__dot fab__dot--phone">
                            <Phone size={19} aria-hidden="true" />
                        </span>
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.youtube.com/channel/UCL4pC3c6TKHzy5-HWqcy9iQ"
                        className="fab__link"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="fab__label">YouTube</span>
                        <span className="fab__dot fab__dot--youtube">
                            <Youtube size={19} aria-hidden="true" />
                        </span>
                    </a>
                </li>
            </ul>

            <button
                type="button"
                className="fab__trigger"
                onClick={() => setOpen((value) => !value)}
                aria-expanded={open}
                aria-label={open ? 'Close contact options' : 'Open contact options'}
            >
                <Sun size={26} aria-hidden="true" />
            </button>
        </div>
    );
}

export default FloatButton;
